export function calculateRemainingAnswers(answers, removedIndex) {
  if (removedIndex < 0 || removedIndex >= answers.length) {
    return answers;
  }

  const remainingAnswers = answers.filter((_, index) => index !== removedIndex);

  const preferredAnswerWasRemoved = answers[removedIndex].isPreferred;

  if (preferredAnswerWasRemoved && remainingAnswers.length > 0) {
    remainingAnswers[0].isPreferred = true;
  }

  return remainingAnswers;
}
